// src/components/AdminRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import { readAuthSafe } from "../utils/auth";
import { usePermissions } from "../utils/permissions";

export default function AdminRoute({ children, pageId = "admin-home" }) {
  const auth = readAuthSafe();
  const { getLevel } = usePermissions();
  const role = (auth?.user?.role || "").toLowerCase();

  const allowedByRole = role === "admin";
  const level = pageId ? getLevel(auth?.user?.role, pageId) : allowedByRole ? "Full" : "None";
  if (!allowedByRole && level === "None") {
    return <Navigate to="/login" replace />;
  }

  return <ProtectedRoute>{children}</ProtectedRoute>;
}


